import api from "./axios";

// Profile + settings shape (full read/write)
export const getMyProfile = async () => {
  const res = await api.get("/api/users/me/profile/");
  return res.data;
};

export const updateMyProfile = async (patch) => {
  const res = await api.patch("/api/users/me/profile/", patch);
  return res.data;
};

// Activity feed (mixed: chats, briefs, syncs, manual asset adds, notifications)
export const getMyActivity = async () => {
  const res = await api.get("/api/users/me/activity/");
  return res.data;
};

// Sessions (placeholder — returns current session only for now)
export const listSessions = async () => {
  const res = await api.get("/api/users/me/sessions/");
  return res.data;
};

// JSON snapshot of the user's data
export const exportMyData = async () => {
  const res = await api.post("/api/users/me/export/");
  return res.data;
};

export const deleteMyAccount = async () => {
  const res = await api.post("/api/users/me/delete/", { confirm: true });
  return res.data;
};

export const changePassword = async ({ current_password, new_password }) => {
  const res = await api.post("/api/auth/password/change/", {
    current_password,
    new_password,
  });
  return res.data;
};

export const completeOnboarding = async () => {
  const res = await api.post("/api/users/me/complete-onboarding/");
  return res.data;
};

// Generates / rotates the public-share slug. Old links break the moment
// a new one is generated.
export const rotateShareSlug = async () => {
  const res = await api.post("/api/users/me/share/rotate/");
  return res.data;
};

// Unauthenticated — used by the /p/:slug page.
export const getPublicPortfolio = async (slug) => {
  const res = await api.get(`/api/public/portfolio/${slug}/`);
  return res.data;
};
